import { opacify } from '../utils/helpers/style.js';
import { colors } from '../constants/colors.js';

var iconButtonThemeNative = {
  primary: {
    color: {
      normal: {
        background: 'primary',
        fill: 'background',
        border: 'primary'
      },
      inverted: {
        background: 'background',
        fill: 'primary',
        border: 'background'
      },
      transparent: {
        background: 'button.desaturated',
        fill: 'primary',
        border: 'button.desaturated'
      }
    }
  },
  secondary: {
    color: {
      normal: {
        background: 'background',
        fill: 'primary',
        border: 'primary'
      },
      inverted: {
        background: 'primary',
        fill: 'background',
        border: 'background'
      },
      transparent: {
        background: 'transparent',
        fill: 'button.desaturated',
        border: 'button.desaturated'
      }
    }
  },
  plain: {
    color: {
      normal: {
        background: 'background',
        fill: 'primary',
        border: 'background'
      },
      inverted: {
        background: 'background',
        fill: 'primary',
        border: 'background'
      },
      transparent: {
        background: 'transparent',
        fill: 'button.desaturated',
        border: 'transparent'
      }
    }
  },
  disabled: {
    color: {
      normal: {
        background: 'button.disabled',
        fill: 'label.disabled',
        border: 'button.disabled'
      },
      inverted: {
        background: 'button.disabled',
        fill: 'label.disabled',
        border: 'button.disabled'
      },
      transparent: {
        background: opacify(colors.snowWhite, 0.2),
        fill: opacify(colors.snowWhite, 0.4),
        border: opacify(colors.snowWhite, 0.2)
      }
    }
  }
};

export { iconButtonThemeNative };
